(function () {
    // WB 24/09/2026 : les avis ont leur propre section `tabs-content`, sous celle
    // de la description. Les onglets se cherchent donc dans TOUS les
    // `tabs-component` de la fiche, plus seulement le premier — sinon « Avis »
    // disparaissait de la barre d'ancres sans erreur.
    function allTabs() {
        return Array.from(document.querySelectorAll('tabs-component [role="tab"]'));
    }

    function buildAutoNav() {
        const autoNav = document.querySelector('.product-anchor-nav--auto');
        if (!autoNav) return;

        const tabs = allTabs();

        const complementaryLabel = autoNav.dataset.complementaryLabel;
        const complementaryEl = document.querySelector('[id^="complementary-products-"]')
            || document.querySelector('product-recommendations.complementary-products');
        const tabsOrder = (autoNav.dataset.tabsOrder || '')
            .split(',')
            .map((s) => s.trim())
            .filter(Boolean);

        // Construire un index label → item depuis les onglets trouvés
        const tabItemsByLabel = {};
        tabs.forEach((tab) => {
            const span = tab.querySelector('span');
            const text = (span ? span.textContent : tab.textContent).trim();
            tabItemsByLabel[text.toLowerCase()] = { label: text, tabTarget: text, anchorId: null };
        });

        // WB 24/09/2026 : une section qui n'est pas un onglet (les avis,
        // `sections/wb-product-reviews.liquid`) se déclare par `data-wb-anchor-label`.
        // Son libellé doit valoir le mot de `tabs_order` dans chaque langue.
        document.querySelectorAll('[data-wb-anchor-label]').forEach((el) => {
            const text = (el.dataset.wbAnchorLabel || '').trim();
            if (!text || !el.id) return;
            tabItemsByLabel[text.toLowerCase()] = { label: text, tabTarget: null, anchorId: el.id };
        });

        const createSep = () => {
            const sep = document.createElement('span');
            sep.className = 'product-anchor-nav__separator';
            sep.setAttribute('aria-hidden', 'true');
            sep.textContent = '|';
            return sep;
        };

        const createBtn = (item) => {
            const btn = document.createElement('button');
            btn.className = 'product-anchor-nav__btn';
            btn.type = 'button';
            btn.textContent = item.label;
            if (item.tabTarget) btn.dataset.tabTarget = item.tabTarget;
            if (item.anchorId) btn.dataset.anchorId = item.anchorId;
            if (item.anchorEl) { btn._anchorEl = item.anchorEl; btn.dataset.anchorEl = 'true'; }
            return btn;
        };

        const compLabelLower = complementaryEl && complementaryLabel ? complementaryLabel.toLowerCase() : null;
        const compItem = compLabelLower ? {
            label: complementaryLabel,
            tabTarget: null,
            anchorId: complementaryEl.id || null,
            anchorEl: complementaryEl.id ? null : complementaryEl
        } : null;

        // Ordre des labels : tabsOrder s'il est défini, sinon onglets naturels + complémentaire en dernier
        const orderedLabels = tabsOrder.length > 0
            ? tabsOrder
            : [
                ...tabs.map((tab) => {
                    const span = tab.querySelector('span');
                    return (span ? span.textContent : tab.textContent).trim();
                }),
                ...(compItem ? [complementaryLabel] : [])
            ];

        // Réserver un placeholder invisible à la bonne position pour le bloc complémentaire
        // (chargé en async) — révélé seulement si recommendations:loaded confirme du contenu
        let compPlaceholder = null;
        let compLeadingSep = null;
        let slotCount = 0;

        orderedLabels.forEach((label) => {
            if (compLabelLower && label.toLowerCase() === compLabelLower && compItem) {
                if (slotCount > 0) {
                    compLeadingSep = createSep();
                    compLeadingSep.hidden = true;
                    autoNav.appendChild(compLeadingSep);
                }
                compPlaceholder = document.createElement('span');
                compPlaceholder.hidden = true;
                autoNav.appendChild(compPlaceholder);
                slotCount++;
                return;
            }

            const item = tabItemsByLabel[label.toLowerCase()];
            if (!item) return;
            if (slotCount > 0) autoNav.appendChild(createSep());
            autoNav.appendChild(createBtn(item));
            slotCount++;
        });

        // Révéler le slot complémentaire seulement si des produits sont retournés
        if (compItem && complementaryEl) {
            complementaryEl.addEventListener('recommendations:loaded', () => {
                if (compPlaceholder?.parentNode) {
                    const btn = createBtn(compItem);
                    compPlaceholder.parentNode.replaceChild(btn, compPlaceholder);
                    if (compLeadingSep) compLeadingSep.hidden = false;
                    initBtn(btn);
                }
            });
            // WB 24/09/2026 : bloc servi en HTML, sans fetch : aucun
            // événement ne viendra, les cartes sont déjà là.
            if (complementaryEl.querySelector('.product-card')) {
                complementaryEl.dispatchEvent(new CustomEvent('recommendations:loaded'));
            }
        }
    }

    function focusTarget(el) {
        if (!el) return;
        // Si l'élément n'est pas nativement focusable, on lui donne temporairement tabindex="-1"
        const nativelyFocusable = /^(a|button|input|select|textarea)$/i.test(el.tagName)
            || el.getAttribute('tabindex') !== null
            || el.getAttribute('role') === 'tab';
        if (!nativelyFocusable) {
            el.setAttribute('tabindex', '-1');
            el.addEventListener('blur', function onBlur() {
                el.removeAttribute('tabindex');
                el.removeEventListener('blur', onBlur);
            });
        }
        el.focus({ preventScroll: true });
    }

    function initBtn(btn) {
        btn.addEventListener('click', function () {
            const { anchorId, tabTarget } = this.dataset;

            if (anchorId) {
                const target = document.getElementById(anchorId);
                if (target) {
                    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    focusTarget(target);
                }
                return;
            }

            if (this._anchorEl) {
                this._anchorEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
                focusTarget(this._anchorEl);
                return;
            }

            if (!tabTarget) return;
            const found = allTabs().find((tab) => {
                const span = tab.querySelector('span');
                return (span ? span.textContent : tab.textContent).trim() === tabTarget;
            });

            if (found) {
                found.click();
                found.closest('tabs-component').scrollIntoView({ behavior: 'smooth', block: 'start' });
                focusTarget(found);
            }
        });
    }

    function initProductAnchorNav() {
        const btns = document.querySelectorAll('.product-anchor-nav__btn[data-tab-target], .product-anchor-nav__btn[data-anchor-id], .product-anchor-nav__btn[data-anchor-el]');
        if (btns.length === 0) return;
        btns.forEach(initBtn);
    }

    function init() {
        buildAutoNav();
        initProductAnchorNav();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
